import qrcode from "qrcode-generator";

/** SVG markup for a QR code pointing at `link`. */
export function qrSvg(link: string): string {
    const qr = qrcode(0, "L");
    qr.addData(link);
    qr.make();
    return qr.createSvgTag(6, 12);
}

function triggerDownload(href: string, filename: string) {
    const a = document.createElement("a");
    a.href = href;
    a.download = filename;
    a.click();
    a.remove();
}

/** Prefer PNG export for shareability; fall back to SVG on error. */
export function downloadQr(link: string, baseName: string) {
    try {
        if (!link) return;
        const svgData =
            "data:image/svg+xml;base64," + window.btoa(qrSvg(link));
        const img = new Image();
        img.onload = () => {
            try {
                const canvas = document.createElement("canvas");
                const size = 1024;
                canvas.width = size;
                canvas.height = size;
                const ctx = canvas.getContext("2d");
                if (!ctx) throw new Error("no_ctx");
                ctx.fillStyle = "#ffffff";
                ctx.fillRect(0, 0, size, size);
                ctx.drawImage(img, 0, 0, size, size);
                triggerDownload(
                    canvas.toDataURL("image/png"),
                    `${baseName}_referral_qr.png`,
                );
            } catch {
                triggerDownload(svgData, `${baseName}_referral_qr.svg`);
            }
        };
        img.onerror = () =>
            triggerDownload(svgData, `${baseName}_referral_qr.svg`);
        img.src = svgData;
    } catch (error) {
        console.error("QR generation error:", error);
    }
}
